export type LicenseTier = 'alpha' | 'shell' | 'kernel' | 'root' | 'standard';

/** Licence « New » : pas encore de serveur dédié associé */
export const isNewLicense = (type?: string): boolean => {
  if (!type) return false;
  return type.trim().toLowerCase() === 'new';
};

export const resolveLicenseTier = (type?: string): LicenseTier => {
  if (!type) return 'standard';
  const n = type.toLowerCase();
  if (n.includes('root')) return 'root';
  if (n.includes('kernel')) return 'kernel';
  if (n.includes('shell')) return 'shell';
  if (n.includes('alpha')) return 'alpha';
  return 'standard';
};

export const formatLicensePlanLabel = (type?: string): string => {
  const tier = resolveLicenseTier(type);
  const labels: Record<LicenseTier, string> = {
    alpha: 'Alpha',
    shell: 'Shell',
    kernel: 'Kernel',
    root: 'Root',
    standard: type || 'Standard',
  };
  return labels[tier];
};

export const readLicenseCounter = (
  source: Record<string, unknown> | null | undefined,
  keys: string[]
): number | undefined => {
  if (!source) return undefined;
  for (const key of keys) {
    const value = source[key];
    if (typeof value === 'number' && Number.isFinite(value)) return Math.trunc(value);
    if (typeof value === 'string' && value.trim() !== '' && Number.isFinite(Number(value))) {
      return Math.trunc(Number(value));
    }
  }
  return undefined;
};

export const licenseCounters = (payload: unknown): { totalScans?: number; level?: number } => {
  const root = payload && typeof payload === 'object' ? (payload as Record<string, unknown>) : undefined;
  const nested = root?.license && typeof root.license === 'object'
    ? (root.license as Record<string, unknown>)
    : undefined;
  const keys = ['totalScans', 'totalScan', 'scansTotal', 'totalScansLaunched'] as const;
  const levels = ['currentLevel', 'level', 'lvl', 'scanLevel'] as const;
  const totalScans = readLicenseCounter(root, [...keys]) ?? readLicenseCounter(nested, [...keys]);
  const level = readLicenseCounter(root, [...levels]) ?? readLicenseCounter(nested, [...levels]);
  return {
    ...(totalScans != null ? { totalScans } : {}),
    ...(level != null ? { level } : {}),
  };
};

export const formatLicenseExpiry = (expiryDate?: string): { text: string; status: 'ok' | 'warn' | 'critical' | 'expired' | 'none' } => {
  if (!expiryDate) return { text: 'Sans expiration', status: 'none' };

  const expiry = new Date(expiryDate);
  const now = new Date();
  const diffDays = Math.ceil((expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return { text: 'Expirée', status: 'expired' };
  if (diffDays <= 7) return { text: `${diffDays}j restants`, status: 'critical' };
  if (diffDays <= 30) return { text: `${diffDays}j restants`, status: 'warn' };
  return { text: `${diffDays}j restants`, status: 'ok' };
};

export const maskLicenseCode = (code?: string, visible = 8): string => {
  if (!code) return '—';
  if (code.length <= visible) return code;
  return `${code.substring(0, visible)}…`;
};
